// import React, { useEffect, useState } from "react";
// import {
//   getVendorItems, addItemVendor, updateItemVendor, deleteItemVendor,
//   getAllParentCategories, getSubcategoriesByParent, bulkUploadVendorItems
// } from "../../services/api";
// import { useNavigate } from "react-router-dom";
// import VendorLayout from "../../components/VendorLayout";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import "../../vendor-panel.css";

// const VendorItems = () => {
//   const navigate = useNavigate();
//   const [items, setItems] = useState([]);
//   const [filteredItems, setFilteredItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editingItem, setEditingItem] = useState(null);
//   const [viewItem, setViewItem] = useState(null);
//   const [parentCategories, setParentCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [bulkFile, setBulkFile] = useState(null);
//   const [bulkResult, setBulkResult] = useState(null);
//   const [bulkUploading, setBulkUploading] = useState(false);

//   const emptyForm = {
//     name: "", description: "", price: "", discountPrice: "", sku: "",
//     stock: "", gstRate: "", hsnSacCode: "", tags: "", seoTitle: "",
//     seoDescription: "", variants: [], parentCategory: "", subCategory: "",
//     image: null, currentImageUrl: ""
//   };

//   const [formData, setFormData] = useState(emptyForm);

//   useEffect(() => { fetchItems(); fetchParentCategories(); }, []);

//   useEffect(() => {
//     if (!searchQuery) { setFilteredItems(items); return; }
//     const q = searchQuery.toLowerCase();
//     setFilteredItems(items.filter(item =>
//       item.name?.toLowerCase().includes(q) ||
//       item.description?.toLowerCase().includes(q) ||
//       item.tags?.some(t => t.toLowerCase().includes(q)) ||
//       item.sku?.toLowerCase().includes(q) ||
//       item.hsnSacCode?.toLowerCase().includes(q)
//     ));
//   }, [searchQuery, items]);

//   const fetchItems = async () => {
//     setLoading(true);
//     try {
//       const res = await getVendorItems();
//       setItems(res.data?.items || []);
//     } catch (err) {
//       setItems([]);
//     } finally { setLoading(false); }
//   };

//   const fetchParentCategories = async () => {
//     try { const res = await getAllParentCategories(); setParentCategories(res.data || []); }
//     catch { setParentCategories([]); }
//   };

//   const fetchSubCategories = async (parentId) => {
//     if (!parentId) { setSubCategories([]); return; }
//     try { const res = await getSubcategoriesByParent(parentId); setSubCategories(res.data || []); }
//     catch { setSubCategories([]); }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image") {
//       setFormData(prev => ({ ...prev, image: files[0] }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//       if (name === "parentCategory") { setFormData(prev => ({ ...prev, subCategory: "" })); fetchSubCategories(value); }
//     }
//   };

//   const handleVariantChange = (index, field, value) => {
//     const newVariants = [...formData.variants];
//     newVariants[index][field] = value;
//     setFormData(prev => ({ ...prev, variants: newVariants }));
//   };

//   const addVariant = () => setFormData(prev => ({ ...prev, variants: [...prev.variants, { name: "", options: "", priceDifference: "" }] }));
//   const removeVariant = (index) => setFormData(prev => ({ ...prev, variants: prev.variants.filter((_, i) => i !== index) }));

//   const resetForm = () => { setFormData(emptyForm); setEditingItem(null); setSubCategories([]); setShowForm(false); };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       if (value === undefined || value === null) return;
//       if (key === "variants") {
//         data.append("variants", JSON.stringify(value.map(v => ({
//           name: v.name,
//           options: v.options.split(",").map(o => o.trim()),
//           priceDifference: v.priceDifference ? Number(v.priceDifference) : 0
//         }))));
//       } else if (key === "tags") {
//         data.append("tags", value.split(",").map(t => t.trim()));
//       } else if (key === "image") {
//         if (value) data.append("image", value);
//       } else {
//         data.append(key, value);
//       }
//     });
//     try {
//       if (editingItem) { await updateItemVendor(editingItem._id, data); alert("Item updated!"); }
//       else { await addItemVendor(data); alert("Item added!"); }
//       resetForm(); fetchItems(); setErrorMessage("");
//     } catch { alert("Failed to save item"); }
//   };

//   const handleEdit = (item) => {
//     setEditingItem(item);
//     setFormData({
//       name: item.name, description: item.description, price: item.price,
//       discountPrice: item.discountPrice || "", sku: item.sku || "",
//       stock: item.stock || "", gstRate: item.gstRate || "",
//       hsnSacCode: item.hsnSacCode || "", tags: item.tags?.join(", ") || "",
//       seoTitle: item.seoTitle || "", seoDescription: item.seoDescription || "",
//       variants: item.variants?.map(v => ({ name: v.name || "", options: v.options?.join(",") || "", priceDifference: v.priceDifference || "" })) || [],
//       parentCategory: item.parentCategory?._id || item.parentCategory,
//       subCategory: item.subCategory?._id || item.subCategory,
//       image: null, currentImageUrl: item.image?.url || ""
//     });
//     fetchSubCategories(item.parentCategory?._id || item.parentCategory);
//     setShowForm(true);
//   };

//   const handleDelete = async (itemId) => {
//     if (!window.confirm("Delete this item?")) return;
//     try { await deleteItemVendor(itemId); fetchItems(); }
//     catch { alert("Failed to delete item"); }
//   };

//   const handleBulkUpload = async () => {
//     if (!bulkFile) return alert("Select a file first");
//     try {
//       setBulkUploading(true);
//       const res = await bulkUploadVendorItems(bulkFile);
//       setBulkResult(res.data); fetchItems();
//     } catch { alert("Bulk upload failed"); }
//     finally { setBulkUploading(false); }
//   };

//   const handleDownloadExcel = () => {
//     if (!filteredItems.length) return alert("No items to download");
//     const data = filteredItems.map(item => ({
//       Name: item.name, Description: item.description, Price: item.price,
//       DiscountPrice: item.discountPrice || "", SKU: item.sku || "",
//       Stock: item.stock || "", GST: item.gstRate || "",
//       HSN_SAC: item.hsnSacCode || "", Tags: item.tags?.join(", ") || "",
//       ParentCategory: item.parentCategory?.name || "", SubCategory: item.subCategory?.name || "",
//     }));
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Items");
//     const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([buf], { type: "application/octet-stream" }), "Vendor_Items.xlsx");
//   };

//   if (loading) return <VendorLayout><div className="vp-loading">Loading items...</div></VendorLayout>;

//   return (
//     <VendorLayout>
//       {/* Bulk Upload */}
//       <div className="vp-card" style={{ marginBottom: 20 }}>
//         <div className="vp-card-header">
//           <div className="vp-card-title">Bulk Operations</div>
//           <button className="vp-btn vp-btn-ghost vp-btn-sm" onClick={handleDownloadExcel}>↓ Download List</button>
//         </div>
//         <div className="vp-card-body">
//           <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
//             <input type="file" accept=".xlsx,.csv" onChange={e => setBulkFile(e.target.files[0])}
//               style={{ flex: "1 1 200px", padding: "8px 12px", border: "1.5px solid var(--border)", borderRadius: 8, fontFamily: "var(--font)", fontSize: 13 }} />
//             <button className="vp-btn vp-btn-primary" onClick={handleBulkUpload} disabled={bulkUploading}>
//               {bulkUploading ? "Uploading..." : "Bulk Upload"}
//             </button>
//           </div>
//           {bulkResult && (
//             <div className="vp-bulk-result" style={{ marginTop: 12 }}>
//               <p>✅ Success: {bulkResult.success}</p>
//               <p>❌ Failed: {bulkResult.failed}</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Add/Edit Form */}
//       <div className="vp-card" style={{ marginBottom: 20 }}>
//         <div className="vp-card-header">
//           <div className="vp-card-title">{editingItem ? "Edit Item" : "Add New Item"}</div>
//           <button
//             className={`vp-btn ${showForm ? "vp-btn-ghost" : "vp-btn-primary"}`}
//             onClick={() => { if (showForm) { resetForm(); } else setShowForm(true); }}
//           >
//             {showForm ? "✕ Close" : "+ Add Item"}
//           </button>
//         </div>
//         {showForm && (
//           <div className="vp-card-body">
//             {errorMessage && <div className="vp-alert vp-alert-error">{errorMessage}</div>}
//             <form onSubmit={handleSubmit}>
//               <div className="vp-section-title" style={{ marginBottom: 14 }}>Product Details</div>
//               <div className="vp-form-grid" style={{ marginBottom: 14 }}>
//                 <div className="vp-form-group"><label>Item Name *</label><input className="vp-input" type="text" name="name" placeholder="Enter item name" value={formData.name} onChange={handleInputChange} required /></div>
//                 <div className="vp-form-group"><label>Price (₹) *</label><input className="vp-input" type="number" name="price" placeholder="0.00" value={formData.price} onChange={handleInputChange} required /></div>
//                 <div className="vp-form-group"><label>Discount Price (₹)</label><input className="vp-input" type="number" name="discountPrice" placeholder="0.00" value={formData.discountPrice} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>SKU</label><input className="vp-input" type="text" name="sku" placeholder="SKU code" value={formData.sku} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>Stock</label><input className="vp-input" type="number" name="stock" placeholder="Quantity" value={formData.stock} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>GST Rate (%)</label><input className="vp-input" type="number" name="gstRate" placeholder="e.g. 18" value={formData.gstRate} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>HSN/SAC Code</label><input className="vp-input" type="text" name="hsnSacCode" placeholder="HSN code" value={formData.hsnSacCode} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>Tags (comma separated)</label><input className="vp-input" type="text" name="tags" placeholder="tag1, tag2" value={formData.tags} onChange={handleInputChange} /></div>
//               </div>
//               <div className="vp-form-group" style={{ marginBottom: 14 }}><label>Description</label><textarea className="vp-textarea" name="description" placeholder="Item description..." value={formData.description} onChange={handleInputChange} /></div>

//               <div className="vp-section-title" style={{ marginBottom: 14, marginTop: 8 }}>SEO & Category</div>
//               <div className="vp-form-grid" style={{ marginBottom: 14 }}>
//                 <div className="vp-form-group"><label>Parent Category *</label>
//                   <select className="vp-select" name="parentCategory" value={formData.parentCategory} onChange={handleInputChange} required>
//                     <option value="">Select Category</option>
//                     {parentCategories.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
//                   </select>
//                 </div>
//                 <div className="vp-form-group"><label>Sub Category</label>
//                   <select className="vp-select" name="subCategory" value={formData.subCategory} onChange={handleInputChange}>
//                     <option value="">Select Sub Category</option>
//                     {subCategories.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
//                   </select>
//                 </div>
//                 <div className="vp-form-group"><label>SEO Title</label><input className="vp-input" type="text" name="seoTitle" placeholder="SEO title" value={formData.seoTitle} onChange={handleInputChange} /></div>
//                 <div className="vp-form-group"><label>Product Image</label><input className="vp-input" type="file" name="image" accept="image/*" onChange={handleInputChange} /></div>
//               </div>
//               <div className="vp-form-group" style={{ marginBottom: 16 }}><label>SEO Description</label><textarea className="vp-textarea" name="seoDescription" placeholder="SEO description" value={formData.seoDescription} onChange={handleInputChange} /></div>

//               <div className="vp-section-title" style={{ marginBottom: 12, marginTop: 8 }}>Variants</div>
//               {formData.variants.map((v, idx) => (
//                 <div key={idx} className="vp-variant-row" style={{ marginBottom: 10 }}>
//                   <div className="vp-form-group"><label>Variant Name</label><input className="vp-input" type="text" placeholder="e.g. Size" value={v.name} onChange={e => handleVariantChange(idx, "name", e.target.value)} /></div>
//                   <div className="vp-form-group"><label>Options (comma separated)</label><input className="vp-input" type="text" placeholder="S, M, L, XL" value={v.options} onChange={e => handleVariantChange(idx, "options", e.target.value)} /></div>
//                   <div className="vp-form-group"><label>Price Diff (₹)</label><input className="vp-input" type="number" placeholder="0" value={v.priceDifference} onChange={e => handleVariantChange(idx, "priceDifference", e.target.value)} /></div>
//                   <button type="button" className="vp-btn vp-btn-danger vp-btn-sm" onClick={() => removeVariant(idx)} style={{ alignSelf: "flex-end", marginBottom: 1 }}>Remove</button>
//                 </div>
//               ))}
//               <button type="button" className="vp-btn vp-btn-ghost vp-btn-sm" style={{ marginBottom: 20 }} onClick={addVariant}>+ Add Variant</button>

//               <div style={{ display: "flex", gap: 10 }}>
//                 <button type="submit" className="vp-btn vp-btn-primary">{editingItem ? "Update Item" : "Add Item"}</button>
//                 {editingItem && <button type="button" className="vp-btn vp-btn-ghost" onClick={resetForm}>Cancel</button>}
//               </div>
//             </form>
//           </div>
//         )}
//       </div>

//       {/* Items Table */}
//       <div className="vp-card">
//         <div className="vp-card-header">
//           <div className="vp-card-title">Your Items ({filteredItems.length})</div>
//           <div className="vp-search">
//             <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
//             <input
//               type="text"
//               placeholder="Search items..."
//               value={searchQuery}
//               onChange={e => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>
//         <div className="vp-card-body" style={{ padding: 0 }}>
//           {filteredItems.length === 0 ? (
//             <div className="vp-empty"><p>No items found.</p></div>
//           ) : (
//             <div className="vp-table-wrapper">
//               <table className="vp-table">
//                 <thead>
//                   <tr>
//                     <th>Image</th>
//                     <th>Name</th>
//                     <th>Price</th>
//                     <th>Discount</th>
//                     <th>SKU</th>
//                     <th>Stock</th>
//                     <th>Category</th>
//                     <th>Sub Category</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredItems.map(item => (
//                     <tr key={item._id}>
//                       <td>{item.image?.url && <img src={item.image.url} alt={item.name} />}</td>
//                       <td style={{ fontWeight: 600 }}>{item.name}</td>
//                       <td>₹{item.price}</td>
//                       <td>{item.discountPrice ? `₹${item.discountPrice}` : "—"}</td>
//                       <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{item.sku || "—"}</td>
//                       <td>{item.stock || "—"}</td>
//                       <td style={{ fontSize: 12 }}>{item.parentCategory?.name || "—"}</td>
//                       <td style={{ fontSize: 12 }}>{item.subCategory?.name || "—"}</td>
//                       <td>
//                         <div style={{ display: "flex", gap: 5 }}>
//                           <button className="vp-btn vp-btn-ghost vp-btn-sm" onClick={() => setViewItem(item)}>View</button>
//                           <button className="vp-btn vp-btn-outline vp-btn-sm" onClick={() => handleEdit(item)}>Edit</button>
//                           <button className="vp-btn vp-btn-danger vp-btn-sm" onClick={() => handleDelete(item._id)}>Del</button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* View Modal */}
//       {viewItem && (
//         <div className="vp-modal-overlay" onClick={() => setViewItem(null)}>
//           <div className="vp-modal" onClick={e => e.stopPropagation()}>
//             <div className="vp-modal-header">
//               <div className="vp-modal-title">{viewItem.name}</div>
//               <button className="vp-modal-close" onClick={() => setViewItem(null)}>✕</button>
//             </div>
//             <div className="vp-modal-body">
//               {viewItem.image?.url && <img src={viewItem.image.url} alt={viewItem.name} style={{ width: "100%", maxHeight: 240, objectFit: "contain", borderRadius: 10, marginBottom: 16, border: "1px solid var(--border)" }} />}
//               <div className="vp-form-grid">
//                 {[["Description", viewItem.description], ["Price", `₹${viewItem.price}`], ["Discount Price", viewItem.discountPrice ? `₹${viewItem.discountPrice}` : "—"], ["SKU", viewItem.sku || "—"], ["Stock", viewItem.stock || "—"], ["GST Rate", viewItem.gstRate ? `${viewItem.gstRate}%` : "—"], ["HSN/SAC", viewItem.hsnSacCode || "—"], ["Tags", viewItem.tags?.join(", ") || "—"], ["Category", viewItem.parentCategory?.name || "—"], ["Sub Category", viewItem.subCategory?.name || "—"]].map(([label, val]) => (
//                   <div key={label} style={{ marginBottom: 10 }}>
//                     <div style={{ fontSize: 11, fontWeight: 700, color: "var(--sky-dark)", textTransform: "uppercase", marginBottom: 2 }}>{label}</div>
//                     <div style={{ fontSize: 13.5, color: "var(--text)", fontWeight: 500 }}>{val}</div>
//                   </div>
//                 ))}
//               </div>
//               {viewItem.variants?.length > 0 && (
//                 <div style={{ marginTop: 12 }}>
//                   <div className="vp-section-title">Variants</div>
//                   {viewItem.variants.map((v, i) => (
//                     <div key={i} style={{ fontSize: 13, padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
//                       <strong>{v.name}:</strong> {v.options.join(", ")} {v.priceDifference ? `(+₹${v.priceDifference})` : ""}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </VendorLayout>
//   );
// };

// export default VendorItems;


import React, { useEffect, useState, useCallback } from "react";
import {
  getVendorItems, addItemVendor, updateItemVendor, deleteItemVendor,
  getAllParentCategories, getSubcategoriesByParent, bulkUploadVendorItems
} from "../../services/api";
import { useNavigate } from "react-router-dom";
import VendorLayout from "../../components/VendorLayout";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../../vendor-panel.css";

// ─── Sub-components defined OUTSIDE to prevent remount on re-render ───────────

const FormField = ({ label, name, type = "text", placeholder, value, onChange, required }) => (
  <div className="vp-form-group">
    <label>{label}{required && " *"}</label>
    <input className="vp-input" type={type} name={name} placeholder={placeholder}
      value={value} onChange={onChange} required={required} />
  </div>
);

const SelectField = ({ label, name, value, onChange, required, children }) => (
  <div className="vp-form-group">
    <label>{label}{required && " *"}</label>
    <select className="vp-select" name={name} value={value} onChange={onChange} required={required}>
      {children}
    </select>
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const emptyForm = {
  name: "", description: "", price: "", originalPrice: "", discountPrice: "", sku: "",
  stock: "", gstRate: "", hsnSacCode: "", tags: "", seoTitle: "",
  seoDescription: "", variants: [], parentCategory: "", subCategory: "",
  image: null, currentImageUrl: "",
};

const emptyVariant = { name: "", options: "", priceDifference: "", stock: "" };

const VendorItems = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingItem, setEditingItem] = useState(null);
  const [viewItem, setViewItem] = useState(null);
  const [parentCategories, setParentCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterSubCategory, setFilterSubCategory] = useState("");
  const [filterStock, setFilterStock] = useState("");
  const [filterDiscount, setFilterDiscount] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkResult, setBulkResult] = useState(null);
  const [bulkUploading, setBulkUploading] = useState(false);
  const [formData, setFormData] = useState(emptyForm);

  // ── Data fetching ────────────────────────────────────────────────────────────

  useEffect(() => { fetchItems(); fetchParentCategories(); }, []);

  useEffect(() => {
    let result = [...items];

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter(item =>
        item.name?.toLowerCase().includes(q) ||
        item.description?.toLowerCase().includes(q) ||
        item.tags?.some(t => t.toLowerCase().includes(q)) ||
        item.sku?.toLowerCase().includes(q) ||
        item.hsnSacCode?.toLowerCase().includes(q)
      );
    }

    if (filterCategory) {
      result = result.filter(item =>
        item.parentCategory?._id === filterCategory || item.parentCategory === filterCategory
      );
    }

    if (filterSubCategory) {
      result = result.filter(item =>
        item.subCategory?._id === filterSubCategory || item.subCategory === filterSubCategory
      );
    }

    if (filterStock === "in_stock") {
      result = result.filter(item => (Number(item.stock) > 0) || (item.variants && item.variants.some(v => Number(v.stock) > 0)));
    } else if (filterStock === "out_of_stock") {
      result = result.filter(item => (!item.stock || Number(item.stock) === 0) && (!item.variants || !item.variants.some(v => Number(v.stock) > 0)));
    }

    if (filterDiscount === "yes") {
      result = result.filter(item => item.discountPrice && Number(item.discountPrice) < Number(item.price));
    } else if (filterDiscount === "no") {
      result = result.filter(item => !item.discountPrice || Number(item.discountPrice) >= Number(item.price));
    }

    if (sortOption === "price_asc") result.sort((a, b) => Number(a.price || 0) - Number(b.price || 0));
    else if (sortOption === "price_desc") result.sort((a, b) => Number(b.price || 0) - Number(a.price || 0));
    else if (sortOption === "name_asc") result.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    else if (sortOption === "name_desc") result.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    else if (sortOption === "stock_asc") result.sort((a, b) => Number(a.stock || 0) - Number(b.stock || 0));
    else if (sortOption === "stock_desc") result.sort((a, b) => Number(b.stock || 0) - Number(a.stock || 0));

    setFilteredItems(result);
  }, [searchQuery, filterCategory, filterSubCategory, filterStock, filterDiscount, sortOption, items]);

  const availableSubCategories = Array.from(
    new Map(
      items
        .filter(item => filterCategory ? (item.parentCategory?._id === filterCategory || item.parentCategory === filterCategory) : true)
        .map(item => [item.subCategory?._id || item.subCategory, item.subCategory])
        .filter(([id, sub]) => id && sub?.name)
    ).values()
  );

  const fetchItems = async () => {
    setLoading(true);
    try { const res = await getVendorItems(); setItems(res.data?.items || []); }
    catch { setItems([]); }
    finally { setLoading(false); }
  };

  const fetchParentCategories = async () => {
    try { const res = await getAllParentCategories(); setParentCategories(res.data || []); }
    catch { setParentCategories([]); }
  };

  const fetchSubCategories = async (parentId) => {
    if (!parentId) { setSubCategories([]); return; }
    try { const res = await getSubcategoriesByParent(parentId); setSubCategories(res.data || []); }
    catch { setSubCategories([]); }
  };

  // ── Form handlers ────────────────────────────────────────────────────────────

  // ✅ useCallback with functional setState — no focus-loss bug
  const handleInputChange = useCallback((e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData(prev => ({ ...prev, image: files[0] }));
    } else if (name === "parentCategory") {
      setFormData(prev => ({ ...prev, parentCategory: value, subCategory: "" }));
      fetchSubCategories(value);
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  }, []);

  const handleVariantChange = useCallback((index, field, value) => {
    setFormData(prev => {
      const newVariants = [...prev.variants];
      newVariants[index] = { ...newVariants[index], [field]: value };
      return { ...prev, variants: newVariants };
    });
  }, []);

  const addVariant = useCallback(() => {
    setFormData(prev => ({ ...prev, variants: [...prev.variants, { ...emptyVariant }] }));
  }, []);

  const removeVariant = useCallback((index) => {
    setFormData(prev => ({ ...prev, variants: prev.variants.filter((_, i) => i !== index) }));
  }, []);

  const resetForm = () => {
    setFormData(emptyForm);
    setEditingItem(null);
    setSubCategories([]);
    setShowForm(false);
    setErrorMessage("");
  };

  // ── Submit ───────────────────────────────────────────────────────────────────

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (key === "variants") {
        // ✅ Include stock per variant
        data.append("variants", JSON.stringify(value.map(v => ({
          name: v.name,
          options: v.options.split(",").map(o => o.trim()).filter(Boolean),
          priceDifference: v.priceDifference ? Number(v.priceDifference) : 0,
          stock: v.stock ? Number(v.stock) : 0,           // ✅ variant stock
        }))));
      } else if (key === "tags") {
        data.append("tags", value.split(",").map(t => t.trim()).filter(Boolean));
      } else if (key === "image") {
        if (value) data.append("image", value);
      } else if (key !== "currentImageUrl") {
        data.append(key, value);
      }
    });

    try {
      if (editingItem) {
        await updateItemVendor(editingItem._id, data);
        alert("Item updated!");
      } else {
        await addItemVendor(data);
        alert("Item added!");
      }
      resetForm();
      fetchItems();
    } catch {
      alert("Failed to save item");
    }
  };

  // ── Edit / Delete ────────────────────────────────────────────────────────────

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      name: item.name || "",
      description: item.description || "",
      price: item.price || "",
      originalPrice: item.originalPrice || "",
      discountPrice: item.discountPrice || "",
      sku: item.sku || "",
      stock: item.stock || "",
      gstRate: item.gstRate || "",
      hsnSacCode: item.hsnSacCode || "",
      tags: item.tags?.join(", ") || "",
      seoTitle: item.seoTitle || "",
      seoDescription: item.seoDescription || "",
      variants: item.variants?.map(v => ({
        name: v.name || "",
        options: v.options?.join(", ") || "",
        priceDifference: v.priceDifference || "",
        stock: v.stock || "",                              // ✅ load variant stock
      })) || [],
      parentCategory: item.parentCategory?._id || item.parentCategory || "",
      subCategory: item.subCategory?._id || item.subCategory || "",
      image: null,
      currentImageUrl: item.image?.url || "",
    });
    fetchSubCategories(item.parentCategory?._id || item.parentCategory);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (itemId) => {
    if (!window.confirm("Delete this item?")) return;
    try { await deleteItemVendor(itemId); fetchItems(); }
    catch { alert("Failed to delete item"); }
  };

  // ── Bulk operations ──────────────────────────────────────────────────────────

  const handleBulkUpload = async () => {
    if (!bulkFile) return alert("Select a file first");
    try {
      setBulkUploading(true);
      const res = await bulkUploadVendorItems(bulkFile);
      setBulkResult(res.data);
      fetchItems();
    } catch { alert("Bulk upload failed"); }
    finally { setBulkUploading(false); }
  };

  const handleDownloadExcel = () => {
    if (!filteredItems.length) return alert("No items to download");
    const data = filteredItems.map(item => ({
      Name: item.name,
      Description: item.description,
      Price: item.price,
      DiscountPrice: item.discountPrice || "",
      SKU: item.sku || "",
      Stock: item.stock || "",
      GST: item.gstRate || "",
      HSN_SAC: item.hsnSacCode || "",
      Tags: item.tags?.join(", ") || "",
      ParentCategory: item.parentCategory?.name || "",
      SubCategory: item.subCategory?.name || "",
      Variants: item.variants?.map(v =>
        `${v.name}(${v.options.join("/")})+₹${v.priceDifference || 0} stock:${v.stock || 0}`
      ).join(" | ") || "",
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Items");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  };

  const handleDownloadTemplate = () => {
    const templateData = [{
      Name: "Sample Product Name",
      Description: "Description of the product",
      Price: "1000",
      DiscountPrice: "900",
      SKU: "SKU-ABC-123",
      Stock: "50",
      GST: "18",
      HSN_SAC: "123456",
      Tags: "fashion, casual",
      ParentCategory: "Category Name",
      SubCategory: "Sub Category Name",
      Variants: "Size(S,M,L)+100 stock:10 | Color(Red,Blue) stock:5"
    }];
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/octet-stream" }), "Bulk_Upload_Template.xlsx");
  };

  // ── Render ───────────────────────────────────────────────────────────────────

  if (loading) return <VendorLayout><div className="vp-loading">Loading items...</div></VendorLayout>;

  return (
    <VendorLayout>

      {/* ── Bulk Upload ── */}
      <div className="vp-card" style={{ marginBottom: 20 }}>
        <div className="vp-card-header">
          <div className="vp-card-title">Bulk Operations</div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="vp-btn vp-btn-outline vp-btn-sm" onClick={handleDownloadTemplate}>↓ Download Template</button>
            <button className="vp-btn vp-btn-ghost vp-btn-sm" onClick={handleDownloadExcel}>↓ Download List</button>
          </div>
        </div>
        <div className="vp-card-body">
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
            <input type="file" accept=".xlsx,.csv" onChange={e => setBulkFile(e.target.files[0])}
              style={{ flex: "1 1 200px", padding: "8px 12px", border: "1.5px solid var(--border)", borderRadius: 8, fontFamily: "var(--font)", fontSize: 13 }} />
            <button className="vp-btn vp-btn-primary" onClick={handleBulkUpload} disabled={bulkUploading}>
              {bulkUploading ? "Uploading..." : "Bulk Upload"}
            </button>
          </div>
          {bulkResult && (
            <div className="vp-bulk-result" style={{ marginTop: 12 }}>
              <p>✅ Success: {bulkResult.success}</p>
              <p>❌ Failed: {bulkResult.failed}</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Add / Edit Form ── */}
      <div className="vp-card" style={{ marginBottom: 20 }}>
        <div className="vp-card-header">
          <div className="vp-card-title">{editingItem ? "Edit Item" : "Add New Item"}</div>
          <button
            className={`vp-btn ${showForm ? "vp-btn-ghost" : "vp-btn-primary"}`}
            onClick={() => { if (showForm) resetForm(); else setShowForm(true); }}
          >
            {showForm ? "✕ Close" : "+ Add Item"}
          </button>
        </div>

        {showForm && (
          <div className="vp-card-body">
            {errorMessage && <div className="vp-alert vp-alert-error">{errorMessage}</div>}
            <form onSubmit={handleSubmit}>

              {/* Product Details */}
              <div className="vp-section-title" style={{ marginBottom: 14 }}>Product Details</div>
              <div className="vp-form-grid" style={{ marginBottom: 14 }}>
                <FormField label="Item Name" name="name" placeholder="Enter item name" value={formData.name} onChange={handleInputChange} required />
                <FormField label="Selling Price (₹)" name="price" type="number" placeholder="0.00" value={formData.price} onChange={handleInputChange} required />
                <FormField label="Original / Cost Price (₹) 🔒 Vendor Only" name="originalPrice" type="number" placeholder="0.00" value={formData.originalPrice} onChange={handleInputChange} />
                <FormField label="Discount Price (₹)" name="discountPrice" type="number" placeholder="0.00" value={formData.discountPrice} onChange={handleInputChange} />
                <FormField label="SKU" name="sku" placeholder="SKU code" value={formData.sku} onChange={handleInputChange} />
                <FormField label="Base Stock" name="stock" type="number" placeholder="Overall quantity" value={formData.stock} onChange={handleInputChange} />
                <FormField label="GST Rate (%)" name="gstRate" type="number" placeholder="e.g. 18" value={formData.gstRate} onChange={handleInputChange} />
                <FormField label="HSN/SAC Code" name="hsnSacCode" placeholder="HSN code" value={formData.hsnSacCode} onChange={handleInputChange} />
                <FormField label="Tags (comma separated)" name="tags" placeholder="tag1, tag2" value={formData.tags} onChange={handleInputChange} />
              </div>

              <div className="vp-form-group" style={{ marginBottom: 14 }}>
                <label>Description</label>
                <textarea className="vp-textarea" name="description" placeholder="Item description..."
                  value={formData.description} onChange={handleInputChange} />
              </div>

              {/* SEO & Category */}
              <div className="vp-section-title" style={{ marginBottom: 14, marginTop: 8 }}>SEO & Category</div>
              <div className="vp-form-grid" style={{ marginBottom: 14 }}>
                <SelectField label="Parent Category" name="parentCategory" value={formData.parentCategory} onChange={handleInputChange} required>
                  <option value="">Select Category</option>
                  {parentCategories.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                </SelectField>
                <SelectField label="Sub Category" name="subCategory" value={formData.subCategory} onChange={handleInputChange}>
                  <option value="">Select Sub Category</option>
                  {subCategories.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                </SelectField>
                <FormField label="SEO Title" name="seoTitle" placeholder="SEO title" value={formData.seoTitle} onChange={handleInputChange} />
                <div className="vp-form-group">
                  <label>Product Image</label>
                  {formData.currentImageUrl && (
                    <img src={formData.currentImageUrl} alt="current"
                      style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, border: "1px solid var(--border)", marginBottom: 6, display: "block" }} />
                  )}
                  <input className="vp-input" type="file" name="image" accept="image/*" onChange={handleInputChange} />
                </div>
              </div>

              <div className="vp-form-group" style={{ marginBottom: 16 }}>
                <label>SEO Description</label>
                <textarea className="vp-textarea" name="seoDescription" placeholder="SEO description"
                  value={formData.seoDescription} onChange={handleInputChange} />
              </div>

              {/* Variants */}
              <div className="vp-section-title" style={{ marginBottom: 12, marginTop: 8 }}>
                Variants
                <span style={{ fontSize: 11, fontWeight: 400, color: "var(--text-muted)", marginLeft: 8 }}>
                  (each variant has its own stock count)
                </span>
              </div>

              {formData.variants.map((v, idx) => (
                <div key={idx} className="vp-variant-row" style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1.5fr 100px 100px auto",
                  gap: 10, alignItems: "flex-end", marginBottom: 10,
                  padding: "12px 14px", background: "var(--surface, #f8fafc)",
                  borderRadius: 10, border: "1px solid var(--border)",
                }}>
                  <div className="vp-form-group" style={{ margin: 0 }}>
                    <label>Variant Name</label>
                    <input className="vp-input" type="text" placeholder="e.g. Size"
                      value={v.name} onChange={e => handleVariantChange(idx, "name", e.target.value)} />
                  </div>
                  <div className="vp-form-group" style={{ margin: 0 }}>
                    <label>Options (comma separated)</label>
                    <input className="vp-input" type="text" placeholder="S, M, L, XL"
                      value={v.options} onChange={e => handleVariantChange(idx, "options", e.target.value)} />
                  </div>
                  <div className="vp-form-group" style={{ margin: 0 }}>
                    <label>Price Diff (₹)</label>
                    <input className="vp-input" type="number" placeholder="0"
                      value={v.priceDifference} onChange={e => handleVariantChange(idx, "priceDifference", e.target.value)} />
                  </div>
                  {/* ✅ NEW: per-variant stock */}
                  <div className="vp-form-group" style={{ margin: 0 }}>
                    <label>Stock</label>
                    <input className="vp-input" type="number" placeholder="0" min="0"
                      value={v.stock} onChange={e => handleVariantChange(idx, "stock", e.target.value)} />
                  </div>
                  <button type="button" className="vp-btn vp-btn-danger vp-btn-sm"
                    style={{ marginBottom: 1 }} onClick={() => removeVariant(idx)}>
                    Remove
                  </button>
                </div>
              ))}

              <button type="button" className="vp-btn vp-btn-ghost vp-btn-sm"
                style={{ marginBottom: 20 }} onClick={addVariant}>
                + Add Variant
              </button>

              <div style={{ display: "flex", gap: 10 }}>
                <button type="submit" className="vp-btn vp-btn-primary">
                  {editingItem ? "Update Item" : "Add Item"}
                </button>
                {editingItem && (
                  <button type="button" className="vp-btn vp-btn-ghost" onClick={resetForm}>Cancel</button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>

      {/* ── Items Table ── */}
      <div className="vp-card">
        <div className="vp-card-header" style={{ flexWrap: "wrap", gap: 10, flexDirection: "column", alignItems: "stretch" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
            <div className="vp-card-title">Your Items ({filteredItems.length})</div>
            <div className="vp-search" style={{ margin: 0 }}>
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
              </svg>
              <input type="text" placeholder="Search items..." value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", paddingTop: 10, borderTop: "1px solid var(--border)" }}>
            <select
              className="vp-select"
              style={{ padding: "6px 30px 6px 12px", minHeight: 34, height: 34, fontSize: 13, width: "auto" }}
              value={filterCategory}
              onChange={e => { setFilterCategory(e.target.value); setFilterSubCategory(""); }}
            >
              <option value="">All Categories</option>
              {parentCategories.map(p => (
                <option key={p._id} value={p._id}>{p.name}</option>
              ))}
            </select>
            <select
              className="vp-select"
              style={{ padding: "6px 30px 6px 12px", minHeight: 34, height: 34, fontSize: 13, width: "auto" }}
              value={filterSubCategory}
              onChange={e => setFilterSubCategory(e.target.value)}
            >
              <option value="">All Sub Categories</option>
              {availableSubCategories.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
            </select>
            <select
              className="vp-select"
              style={{ padding: "6px 30px 6px 12px", minHeight: 34, height: 34, fontSize: 13, width: "auto" }}
              value={filterStock}
              onChange={e => setFilterStock(e.target.value)}
            >
              <option value="">All Stock Status</option>
              <option value="in_stock">In Stock</option>
              <option value="out_of_stock">Out of Stock</option>
            </select>
            <select
              className="vp-select"
              style={{ padding: "6px 30px 6px 12px", minHeight: 34, height: 34, fontSize: 13, width: "auto" }}
              value={filterDiscount}
              onChange={e => setFilterDiscount(e.target.value)}
            >
              <option value="">All Discounts</option>
              <option value="yes">Discounted</option>
              <option value="no">No Discount</option>
            </select>
            <select
              className="vp-select"
              style={{ padding: "6px 30px 6px 12px", minHeight: 34, height: 34, fontSize: 13, width: "auto" }}
              value={sortOption}
              onChange={e => setSortOption(e.target.value)}
            >
              <option value="">Sort By: Default</option>
              <option value="name_asc">Name (A-Z)</option>
              <option value="name_desc">Name (Z-A)</option>
              <option value="price_asc">Price (Low to High)</option>
              <option value="price_desc">Price (High to Low)</option>
              <option value="stock_asc">Stock (Low to High)</option>
              <option value="stock_desc">Stock (High to Low)</option>
            </select>

            {(filterCategory || filterSubCategory || filterStock || filterDiscount || sortOption) && (
              <button
                className="vp-btn vp-btn-ghost"
                style={{ padding: "6px 12px", height: 34, fontSize: 13 }}
                onClick={() => {
                  setFilterCategory("");
                  setFilterSubCategory("");
                  setFilterStock("");
                  setFilterDiscount("");
                  setSortOption("");
                }}
              >
                Clear Filters
              </button>
            )}
          </div>
        </div>
        <div className="vp-card-body" style={{ padding: 0 }}>
          {filteredItems.length === 0 ? (
            <div className="vp-empty"><p>No items found.</p></div>
          ) : (
            <div className="vp-table-wrapper">
              <table className="vp-table">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Selling Price</th>
                    <th>Original Price 🔒</th>
                    <th>Discount</th>
                    <th>SKU</th>
                    <th>Base Stock</th>
                    <th>Variants</th>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map(item => (
                    <tr key={item._id}>
                      <td>
                        {item.image?.url && (
                          <img src={item.image.url} alt={item.name}
                            style={{ width: 44, height: 44, objectFit: "cover", borderRadius: 6 }} />
                        )}
                      </td>
                      <td style={{ fontWeight: 600 }}>{item.name}</td>
                      <td>₹{item.price}</td>
                      <td>
                        <span style={{ color: "#b45309", fontWeight: 600, background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 6, padding: "2px 8px", fontSize: "0.85em" }}>
                          {item.originalPrice ? `₹${item.originalPrice}` : "—"}
                        </span>
                      </td>
                      <td>{item.discountPrice ? `₹${item.discountPrice}` : "—"}</td>
                      <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{item.sku || "—"}</td>
                      <td>{item.stock ?? "—"}</td>
                      {/* ✅ Show variant count + total variant stock */}
                      <td style={{ fontSize: 12 }}>
                        {item.variants?.length
                          ? <span title={item.variants.map(v => `${v.name}: stock ${v.stock || 0}`).join("\n")}
                            style={{ cursor: "help", borderBottom: "1px dashed var(--text-muted)" }}>
                            {item.variants.length} variant{item.variants.length !== 1 ? "s" : ""}
                            {" "}(stock: {item.variants.reduce((sum, v) => sum + (v.stock || 0), 0)})
                          </span>
                          : "—"}
                      </td>
                      <td style={{ fontSize: 12 }}>{item.parentCategory?.name || "—"}</td>
                      <td style={{ fontSize: 12 }}>{item.subCategory?.name || "—"}</td>
                      <td>
                        <div style={{ display: "flex", gap: 5 }}>
                          <button className="vp-btn vp-btn-ghost vp-btn-sm" onClick={() => setViewItem(item)}>View</button>
                          <button className="vp-btn vp-btn-outline vp-btn-sm" onClick={() => handleEdit(item)}>Edit</button>
                          <button className="vp-btn vp-btn-danger vp-btn-sm" onClick={() => handleDelete(item._id)}>Del</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ── View Modal ── */}
      {viewItem && (
        <div className="vp-modal-overlay" onClick={() => setViewItem(null)}>
          <div className="vp-modal" onClick={e => e.stopPropagation()}>
            <div className="vp-modal-header">
              <div className="vp-modal-title">{viewItem.name}</div>
              <button className="vp-modal-close" onClick={() => setViewItem(null)}>✕</button>
            </div>
            <div className="vp-modal-body">
              {viewItem.image?.url && (
                <img src={viewItem.image.url} alt={viewItem.name}
                  style={{ width: "100%", maxHeight: 240, objectFit: "contain", borderRadius: 10, marginBottom: 16, border: "1px solid var(--border)" }} />
              )}
              <div className="vp-form-grid">
                {[
                  ["Description", viewItem.description],
                  ["Selling Price", `₹${viewItem.price}`],
                  ["Original / Cost Price 🔒", viewItem.originalPrice ? `₹${viewItem.originalPrice}` : "—"],
                  ["Discount Price", viewItem.discountPrice ? `₹${viewItem.discountPrice}` : "—"],
                  ["SKU", viewItem.sku || "—"],
                  ["Base Stock", viewItem.stock ?? "—"],
                  ["GST Rate", viewItem.gstRate ? `${viewItem.gstRate}%` : "—"],
                  ["HSN/SAC", viewItem.hsnSacCode || "—"],
                  ["Tags", viewItem.tags?.join(", ") || "—"],
                  ["Category", viewItem.parentCategory?.name || "—"],
                  ["Sub Category", viewItem.subCategory?.name || "—"],
                ].map(([label, val]) => (
                  <div key={label} style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "var(--sky-dark)", textTransform: "uppercase", marginBottom: 2 }}>{label}</div>
                    <div style={{ fontSize: 13.5, color: "var(--text)", fontWeight: 500 }}>{val}</div>
                  </div>
                ))}
              </div>

              {/* ✅ Variants with stock in modal */}
              {viewItem.variants?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div className="vp-section-title" style={{ marginBottom: 8 }}>Variants</div>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: "var(--surface, #f8fafc)" }}>
                        <th style={thStyle}>Name</th>
                        <th style={thStyle}>Options</th>
                        <th style={thStyle}>Price Diff</th>
                        <th style={thStyle}>Stock</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewItem.variants.map((v, i) => (
                        <tr key={i} style={{ borderBottom: "1px solid var(--border)" }}>
                          <td style={tdStyle}>{v.name || "—"}</td>
                          <td style={tdStyle}>{v.options?.join(", ") || "—"}</td>
                          <td style={tdStyle}>{v.priceDifference ? `+₹${v.priceDifference}` : "—"}</td>
                          <td style={{ ...tdStyle, fontWeight: 600 }}>{v.stock ?? 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </VendorLayout>
  );
};

// Table cell styles (defined outside render to avoid recreation)
const thStyle = { padding: "6px 10px", textAlign: "left", fontWeight: 700, fontSize: 11, textTransform: "uppercase", color: "var(--text-muted)" };
const tdStyle = { padding: "6px 10px", color: "var(--text)" };

export default VendorItems;